import { jsx as _jsx } from "react/jsx-runtime";
import { tableHeadClasses as muiTableHeadClasses } from '@mui/material';
import { forwardRef } from 'react';
import { TableHeadStyled } from './TableHead.styled';
const TableHead = forwardRef((props, ref) => {
    return _jsx(TableHeadStyled, { ref: ref, ...props });
});
export { TableHead };
export const tableHeadClasses = muiTableHeadClasses;
